import {z} from 'zod';

import {
  optionalNonNegativeIntInput,
  optionalPowerInput,
  optionalText,
  powerInput,
} from '../utils/catalogueUi';
import {engineTechnicalDataSchema} from './engineTechnicalDataSchema';

export const engineSchema = z.object({
  name: z.string().min(1),
  fuel: z.string().min(1),
  hybridType: optionalText,
  powerKw: powerInput,
  powerPs: optionalPowerInput,
  displacementCcm: optionalNonNegativeIntInput,
  transmission: z.string().trim().min(1),
  drive: z.string().trim().min(1),
  factoryCode: z.string(),
});

/** The catalogue engine dialogs also edit the engine's technical data; the new-model wizard does not. */
export const engineAuthoringSchema = engineSchema.extend({
  technicalData: engineTechnicalDataSchema,
});
export type EngineAuthoringValues = z.infer<typeof engineAuthoringSchema>;
